import { ContentDecisionListResponse, ContentPublicationListResponse, } from '@wit-support/admin-contracts';
import { CONTENT_API_BASE as BASE, contentQs as qs, contentRequest as request } from '../api.js';
/** GET /publications?page&pageSize — постраничный режим (`total/page/pageSize`). */
export function listPublicationsPage(q) {
    return request(ContentPublicationListResponse, `${BASE}/publications${qs({
        account: q.account,
        network: q.network,
        period: q.from || q.to ? undefined : q.period,
        from: q.from,
        to: q.to,
        reason: q.reason,
        tier: q.tier,
        source: q.source,
        format: q.format,
        sort: q.sort,
        dir: q.dir,
        page: String(q.page),
        pageSize: String(q.pageSize),
    })}`);
}
/** GET /decisions — журнал решений постранично (без периода — весь журнал). */
export function listDecisionsPage(q) {
    return request(ContentDecisionListResponse, `${BASE}/decisions${qs({
        account: q.account,
        period: q.from || q.to ? undefined : q.period,
        from: q.from,
        to: q.to,
        sort: q.sort,
        dir: q.sort !== undefined ? q.dir : undefined,
        page: String(q.page),
        pageSize: String(q.pageSize),
    })}`);
}
//# sourceMappingURL=publications.js.map